import { render } from "./Layout.vue?vue&type=template&id=272aa57e&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.4.29_typescript@5.5.2__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__